import React from 'react';

interface AppProviderProps {
    children: React.ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({children}) => {
    // Здесь могут быть глобальные провайдеры контекста
    // Например: ThemeProvider, AuthProvider, ApiProvider
    return <>{children}</>;
};
